export const AnnualSurveySchema = "survey:2025";
export const OnboardingSurveySchema = "survey:onboarding";
export const QldSurveySchema = "survey:qld";

export type SurveySchema = typeof AnnualSurveySchema | typeof OnboardingSurveySchema | typeof QldSurveySchema;

export const KnownSurveys: SurveySchema[] = [AnnualSurveySchema, OnboardingSurveySchema, QldSurveySchema];

export type SurveyResponse = {
    valid(): boolean;
};

export interface SurveyData {
    id: string;
    title: string;
    schema: SurveySchema;
}

export type SurveyPayload = {
    id: string;
    response: SurveyResponse;
};
